import styled from "styled-components";

export const InputEmojiContainer = styled.div`
  margin-bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => props.theme.colors.typography1.dark};
  border-radius: 12px;
  position: relative;

  > input {
    flex: 1;
    margin: 0;
    border: none;
    outline: none;
    :focus {
      border: none;
    }
  }

  > button {
    background-color: transparent;
    border: none;
    padding: 10px;

    > svg {
      color: ${(props) => props.theme.colors.typography1.dark};
      width: 20px;
      height: 20px;
    }
  }
`;

export const EmojiPickerWrapper = styled.div`
  position: absolute;
  top: 105%;
  left: 0;
  z-index: 1;

  > aside {
    width: 100%;
  }
`;